import { ChevronDownIcon } from '@radix-ui/react-icons';
import * as React from 'react';
import { cn } from '@/lib/utils';

export type NativeSelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
	({ className, children, ...props }, ref) => {
		return (
			<div className="relative">
				<select
					className={cn(
						'flex h-9 w-full appearance-none items-center rounded-md border border-input bg-background pl-3 pr-6 py-2 text-sm ring-offset-background focus:outline-none focus:ring-3 focus:ring-neutral-100 disabled:cursor-not-allowed disabled:opacity-50',
						className
					)}
					ref={ref}
					{...props}
				>
					{children}
				</select>
				<ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50" />
			</div>
		);
	}
);
NativeSelect.displayName = 'NativeSelect';

export { NativeSelect };
